module.exports = __webpack_public_path__ + "static/media/16-1.92db5411.mp3";